import { fetchNoToken } from "../helpers/fetch";
import { propertyActions } from "../store/propertySlice";
import { showSimpleMessage } from "./ui";

export const startGetFeaturedProperty = () => {
  return async (dispatch) => {
    dispatch(propertyActions.startLoadingFeaturedProperty());
    try {
      const response = await fetchNoToken("featured_property");
      const body = await response.json();
      if (body.errors) {
      } else {
        dispatch(propertyActions.loadFeaturedProperty([body]));
        dispatch(propertyActions.stopLoadingFeaturedProperty());
      }
    } catch (error) {
      dispatch(
        propertyActions.featuredPropertyError("Error obteniendo informacion")
      );
    }
  };
};

export const startGetLatestProperties = () => {
  return async (dispatch) => {
    dispatch(propertyActions.startLoadingLatestProperties());
    try {
      const response = await fetchNoToken("latest_properties");
      const body = await response.json();
      if (body.errors) {
      } else {
        dispatch(propertyActions.loadLatestProperties(body));
        dispatch(propertyActions.stopLoadingLatestProperties());
      }
    } catch (error) {
      dispatch(
        propertyActions.latestPropertiesError("Error obteniendo informacion")
      );
    }
  };
};

export const startGetRentProperties = () => {
  return async (dispatch) => {
    dispatch(propertyActions.startLoadingListProperties());
    try {
      const response = await fetchNoToken("rent");
      const body = await response.json();
      if (body.errors) {
      } else {
        dispatch(propertyActions.loadListProperties(body));
        dispatch(propertyActions.stopLoadingListProperties());
      }
    } catch (error) {
      dispatch(
        propertyActions.errorListProperties("Error obteniendo informacion")
      );
    }
  };
};

export const startGetBuyProperties = () => {
  return async (dispatch) => {
    dispatch(propertyActions.startLoadingListProperties());
    try {
      const response = await fetchNoToken("buy");
      const body = await response.json();
      if (body.errors) {
      } else {
        dispatch(propertyActions.loadListProperties(body));
        dispatch(propertyActions.stopLoadingListProperties());
      }
    } catch (error) {
      dispatch(
        propertyActions.errorListProperties("Error obteniendo informacion")
      );
    }
  };
};

export const startGetProperties = (filters) => {
  return async (dispatch) => {
    dispatch(propertyActions.startLoadingListProperties());
    try {
      const response = await fetchNoToken(
        "static_pages_properties",
        filters,
        "POST"
      );
      const body = await response.json();
      if (body.errors) {
      } else {
        dispatch(propertyActions.loadListProperties(body));
        dispatch(propertyActions.stopLoadingListProperties());
      }
    } catch (error) {
      dispatch(
        propertyActions.errorListProperties("Error obteniendo informacion")
      );
    }
  };
};

export const startGetPropertyDetail = (code) => {
  return async (dispatch) => {
    dispatch(propertyActions.startLoadingProperty());
    try {
      const response = await fetchNoToken("show_property_by_code/" + code);
      const body = await response.json();
      if (body.errors) {
      } else {
        dispatch(propertyActions.loadProperty(body));
        dispatch(propertyActions.stopLoadingProperty());
      }
    } catch (error) {
      dispatch(propertyActions.errorProperty("Error obteniendo informacion"));
    }
  };
};
export const startConsignProperty = (data) => {
  return async (dispatch) => {
    dispatch(propertyActions.startLoadingConsignProperty());
    try {
      const response = await fetchNoToken("consign_save", data, "POST");
      const body = await response.json();
      if (body.errors) {
      } else {
        //dispatch(propertyActions.loadProperty(body));
        dispatch(propertyActions.stopLoadingConsignProperty());
        dispatch(propertyActions.clearConsignDataPropertyForm());
        dispatch(
          showSimpleMessage(
            "Proceso exitoso",
            "Recibimos su informacion. Pronto nos comunicaremos con usted"
          )
        );
      }
    } catch (error) {
      //dispatch(propertyActions.stopLoadingConsignProperty());
      dispatch(
        propertyActions.errorConsignProperty("Error obteniendo informacion")
      );
    }
  };
};
